// ABOUTME: Main service desk page component for warehouse support ticket management.
// ABOUTME: Displays dashboard metrics, tabs for different views, and the main service desk interface.

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

import { endOfMonth, format, startOfMonth } from "date-fns";
import { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import OverflowRow from "../../../../components/theme/OverflowRow";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { useGetDashboardOrderTotalsQuery } from "../../../../newapi/order/ordersSlice";
import { useGetSupportTicketDashboardQuery } from "../../../../newapi/warehouse/supportTicketApiSlice";
import OpenTickets from "./views/OpenTickets";
import UnassignedTickets from "./views/UnassignedTickets";
import ServiceDeskWorkScreen from "./views/WorkScreen";
import WarehouseServiceDeskHistory from "./views/History";
import { warehouseRelationServiceConfig } from "./warehouseRelationServiceConfig";
import { useSelector } from "react-redux";
import ServicedeskSettings from "./views/ServicedeskSettings";
import { ServiceTicketDeltaCard, ServiceUnassignedCard, ServiceNeedsReviewCard, ServiceLengthOfStayCard, ServiceResponsibilityCard } from "./components/ServiceCards";


const TopRow = (props) => {
    const currentDate = new Date();

    const [totalsDates, setTotalsDates] = useState({
        startDate : format(startOfMonth(currentDate), 'yyyy-MM-dd'),
        endDate : format(endOfMonth(currentDate), 'yyyy-MM-dd'),
    });

    // Fetch dashboard metrics - poll every 3 minutes
    const { data: dashboardData, isLoading, isFetching } = useGetSupportTicketDashboardQuery(
        {},
        { pollingInterval: 180000 }
    );

    return (
        <OverflowRow>
            <Box
                sx={{
                    // background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                    flex:2,
                    // boxShadow: '0px 1px 2px 1px rgba(49, 65, 95, 0.15)',
                    position:"relative", //Needed for absolutely positioned things
                    // width:1,
                    borderRadius:4,
                    display:"flex",
                    gap:3,
                    // "@media screen and (max-width: 47.9375em)" : {
                    //     width: "unset"
                    // }
                }}
            >
                <ServiceTicketDeltaCard data={dashboardData} isLoading={isLoading} isFetching={isFetching} />

                <ServiceUnassignedCard data={dashboardData} isLoading={isLoading} isFetching={isFetching} />

                <ServiceNeedsReviewCard data={dashboardData} isLoading={isLoading} isFetching={isFetching} />

                <Box
                  sx={{
                    flex:1,
                  }}
                />

                <ServiceLengthOfStayCard data={dashboardData} isLoading={isLoading} isFetching={isFetching} />

                <ServiceResponsibilityCard data={dashboardData} isLoading={isLoading} isFetching={isFetching} />
            </Box>
        </OverflowRow>
    )
}


const WarehouseServiceDesk = () => {
  const { t, ready } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [config, setConfig] = useState(warehouseRelationServiceConfig());

  // Same cache entry as the TopRow cards and the sidebar badge, so the view counts follow their polling.
  const { data: dashboardData } = useGetSupportTicketDashboardQuery({});

  useEffect(() => {
    setConfig(warehouseRelationServiceConfig(dashboardData?.data));
  }, [dashboardData]);

  const cardStyle = {
    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
    borderRadius: 4,
    padding: 3,
    minWidth: 180,
    flexShrink: 0,
  };

  return (
    <Box sx={{ background: "", width: 1, paddingTop: 9 }}>
        <TopRow
            // setTableConfig={setTableConfig}
        />

      <TabView3
        tabConfig={config}
        sx={{
          minHeight: "calc(100% - 220px)",
          background: `${
            theme.palette.mode === "dark"
              ? colors.grey[200]
              : colors.grey[0]
          }`,
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",

          "&:before": {
            content: "''",
            display: "block",
            width: "32px",
            height: "32px",
            position: "absolute",
            left: 0,
            zIndex: 1,
            backgroundColor: `${
              theme.palette.mode === "dark"
                ? colors.grey[200]
                : colors.grey[0]
            }`,
            top: "40px",
            height: "48px",
            width: "24px",
            borderTopLeftRadius: "24px",
            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
            transition: "250ms",
          },

          "&:after": {
            content: "''",
            display: "block",
            width: "32px",
            height: "32px",
            position: "absolute",
            top: 0,
            zIndex: 1,
            backgroundColor: `${
              theme.palette.mode === "dark"
                ? colors.grey[200]
                : colors.grey[0]
            }`,
            top: "40px",
            right: 0,
            height: "48px",
            width: "24px",
            borderTopLeftRadius: "24px",
            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
            transform: "scaleX(-1)",
            transition: "250ms",
          },

          "@media screen and (max-width: 47.9375em)": {
            "&:after, &:before": {
              top: "-0px",
            },
          },
        }}
      >
        <>
          <ServiceDeskWorkScreen config={config.workscreen} />
          <OpenTickets config={config.opentickets} />
          <UnassignedTickets config={config.unassigned} />
          <WarehouseServiceDeskHistory config={config.history} />
          <ServicedeskSettings config={config.settings} />
        </>
      </TabView3>
    </Box>
  );
};

export default WarehouseServiceDesk;
